import { FilterOperations } from 'business/definitions';
import { snakify } from 'helpers/syntaxHelper';
import _ from 'lodash';

export type UpdateFilters = (newFilterData: Partial<SentenceFilterT>) => void;

/**
 * Helper that updates a list of filters with a new entry
 * @param oldFilters : the obsolete list of filters to update
 * @param newFilterData : the new entry we want to patch
 */
export const getUpdatedFilters = (
    oldFilters: SentenceFilterT[],
    newFilterData: Partial<SentenceFilterT>,
): SentenceFilterT[] =>
    oldFilters.map((oldFilter) =>
        oldFilter.field === newFilterData.field
            ? { ...oldFilter, value: newFilterData.value! }
            : oldFilter,
    );

/**
 * Remove filters with empty or null values for 'in' or 'not_in' operations.
 * @param filters - The array of filters to be processed.
 * @return The filtered array of filters.
 */
export const removeEmptyInNotInFilters = (
    filters: QueryFilterT[],
): QueryFilterT[] => {
    return filters.filter(
        (f) =>
            !(
                (f.operation === FilterOperations.in_ ||
                    f.operation === FilterOperations.not_in) &&
                (f.value === '' || f.value === null)
            ),
    );
};

/**
 * Transforms the `field` property of each filter in the provided array to snake_case format.
 * @param filters - An array of filters, where each filter contains fields like `field`, `operation`, and `value`.
 * @returns A new array of filters with the `field` property in snake_case.
 */
export const snakifyFiltersFields = (
    filters: QueryFilterT[],
): QueryFilterT[] => {
    return filters.map((filter) => ({
        ...filter,
        field: snakify(filter.field),
    }));
};
